module.exports = __webpack_public_path__ + "static/media/uh-oh-dog.86fe5a37.svg";